import React from 'react';
// Analytics
import { usePageTracking } from '../../hooks/useAnalytics';
// Components
import Navbar from '../../components/nav/Navbar';
import FooterComponent from '../../components/footer/FooterComponent';
import HomePageMainContainer from '../../components/home/HomePageMainContainer';
import { HelmetItem } from '../../components/utils/HelmetItem';
// Constants
import { CompanyName } from '../../utils/Constants';
// Data
import {
  homePageAdditionalMeta,
  homePageStructuredData,
} from '../../utils/data/MetaData';
import HomePageHeader from '../../components/home/HomePageHeader';

const HomePage = React.memo(() => {
  usePageTracking();

  return (
    <>
      <HelmetItem
        PageName='Home'
        desc={`${CompanyName} offers commercials, UGC creation, and wellness coaching from Drammen, Norway — available worldwide.`}
        keywords={`Siv Renate, ${CompanyName}, commercials, UGC creator, wellness coaching, mental wellness, worldwide`}
        additionalMeta={homePageAdditionalMeta}
        structuredData={homePageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        <div className='grid'>
          {/* Navigation */}
          <div className='grid relative grid-rows-reg min-h-screen h-screen max-h-screen'>
            <Navbar />
            <HomePageHeader />
          </div>

          {/* Main page content */}
          <HomePageMainContainer />

          {/* Footer */}
          <FooterComponent />
        </div>
      </div>
    </>
  );
});

export default HomePage;
